import React from 'react';
import { Button, Divider, Tooltip } from 'antd';
import AddressFormFields from './AddressFormFields';
import { HouseAddress } from 'pages/Search/models';

const ButtonGroup = Button.Group;

const AddressesFormFields: any = ({
  fields,
  meta: { error },
  rowStyle,
  inputStyle,
  handleFieldFocus,
  startingTabIndex = 0,
  includeApartmentNumberField = false,
  fieldsDisabled = false,
}: any) => {
  const addLimit = 5;
  const removeLimit = 1;
  let tabIndex: number = startingTabIndex;
  const tabIndexIncrement: number = includeApartmentNumberField ? 300 : 200;

  const getNextStartingTabIndex = (addressIndex: number): number => {
    if (tabIndex === 0 || addressIndex === 0) return tabIndex;
    return (tabIndex += tabIndexIncrement);
  };

  return (
    <>
      {fields.map((address: HouseAddress, index: number) => (
        <section key={index}>
          <AddressFormFields
            handleFieldFocus={handleFieldFocus}
            tabNamePrefix={`${address}`}
            rowStyle={rowStyle}
            inputStyle={inputStyle}
            startingTabIndex={getNextStartingTabIndex(index)}
            includeApartmentNumberField={includeApartmentNumberField}
            fieldsDisabled={fieldsDisabled}
            index={index}
          />
          <ButtonGroup className={rowStyle}>
            <Tooltip title={`Remove Address`}>
              <Button
                tabIndex={-1}
                type="danger"
                size="small"
                icon="minus"
                onClick={() => fields.remove(index)}
                disabled={fields.length === removeLimit}
              >
                Remove Address
              </Button>
            </Tooltip>
            {fields.length - 1 === index && (
              <Tooltip
                title={`Add Address (the limit is ${addLimit} addresses)`}
              >
                <Button
                  tabIndex={-1}
                  type="primary"
                  size="small"
                  icon="plus"
                  onClick={() => fields.push({ houseNumber: '', street: '' })}
                  disabled={fields.length >= addLimit}
                >
                  Add Address
                </Button>
              </Tooltip>
            )}
          </ButtonGroup>
          <Divider dashed />
        </section>
      ))}
    </>
  );
};

export default AddressesFormFields;
